import { render, staticRenderFns } from "./dashboard-status.vue?vue&type=template&id=29009ae6&scoped=true&"
import script from "./dashboard-status.vue?vue&type=script&lang=js&"
export * from "./dashboard-status.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-status.vue?vue&type=style&index=0&id=29009ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29009ae6",
  null
  
)

export default component.exports